import React,{useState, useRef } from "react";
import { updateQuestion } from "../../requests/question";
import { InputNumber, Form, Input, Radio, Button, message, Spin, Select, Divider,Space, Empty, List, Avatar, theme, Checkbox} from 'antd';
import { SingleChoiceItem, EditSingleChoiceItem } from "../../components/SingleChoiceItem/SingleChoiceItem";
import { EditQuestionAndAnswerItem, QuestionAndAnswerItem } from "../../components/QuestionAndAnswerItem/QuestionAndAnswerItem";
import { EditMultipleChoiceItem, MultipleChoiceItem } from "../../components/MultipleChoiceItem/MultipleChoiceItem";
import { EditOutlined, MoreOutlined } from "@ant-design/icons";

function QuestionList (props){

    const {hasEdit, defaultPageSize, questionList, setQuestionList} = props;
    // const [questionList, setQuestionList] = useState(props.questionList);
    const [current, setCurrent] = useState(1);
    const itemChangeStorageRef = useRef(new Map());
    const [pageSize, setPageSize] = useState(defaultPageSize || 10);
    const user = JSON.parse(localStorage.getItem('user'));
   
    const handleEdit = (item)=>{
        const tempList = questionList.slice();
        tempList.forEach((element, index) => {
            if(element.question_id === item.question_id){
                tempList[index] = {...tempList[index], isEdit: true};
            }
        });
        setQuestionList(tempList);
    }

    const handleMore = (item)=>{
        const tempList = questionList.slice();
        tempList.forEach((element, index) => {
            if(element.question_id === item.question_id){
                tempList[index] = {...tempList[index], isMore: !tempList[index].isMore};
            }
        });
        setQuestionList(tempList);
    }

    const handleConfirm = async (item)=>{
        const tempList = questionList.slice();
        let data;
        tempList.forEach((element, index) => {
            if(element.question_id === item.question_id){
                tempList[index].isEdit = false;
                if(itemChangeStorageRef.current.has(element.question_id)){
                    tempList[index] = {...itemChangeStorageRef.current.get(element.question_id), isEdit: false};
                    data = tempList[index];
                    itemChangeStorageRef.current.delete(element.question_id);
                }
            }
        });
        if(data){
            await updateQuestion(item.question_id, data);
        }
        setQuestionList(tempList);
    }

    const handleCancel = (item)=>{
        const tempList = questionList.slice();
        tempList.forEach((element, index) => {
            if(element.question_id === item.question_id){
                tempList[index] = {...tempList[index], isEdit: false};
            }
        });
        itemChangeStorageRef.current.delete(item.question_id);
        setQuestionList(tempList);
    }

    const handleAnswerChange = (item, changedValues)=>{
        if(itemChangeStorageRef.current.has(item.question_id)){
            itemChangeStorageRef.current.set(item.question_id, {...itemChangeStorageRef.current.get(item.question_id), ...changedValues});
        }else{
            itemChangeStorageRef.current.set(item.question_id, {...item, ...changedValues});
        }
    } 



    return (
        <List
            itemLayout="vertical"
            dataSource={questionList}
            pagination={{position: 'bottom', align: 'center', defaultPageSize: defaultPageSize, defaultCurrent: current, total:questionList.length, onChange: setCurrent, onShowSizeChange: (cur, size)=>{setCurrent(cur); setPageSize(size)}}}
            renderItem={(item, index) => {
                switch(item.type){
                    case 1:{
                        return <List.Item
                            actions={!item.isEdit ? 
                                [
                                    hasEdit && <a onClick={()=>handleEdit(item)}><Space><EditOutlined /><span>Edit</span></Space></a>,
                                    <a onClick={()=>handleMore(item)}><Space><MoreOutlined /><span>More</span></Space></a>].filter(x=>x)
                                : 
                                [
                                    <a onClick={()=>handleConfirm(item)}><Space><EditOutlined /><span>Confirm</span></Space></a>,
                                    <a onClick={()=>handleCancel(item)}><Space><EditOutlined /><span>Cancel</span></Space></a>
                                ]
                            }
                        >
                            {!item.isEdit ? <SingleChoiceItem item={item} index={index} current={current} pageSize={pageSize}/>
                            :
                            <EditSingleChoiceItem  item={item} index={index} handleAnswerChange={(changedValues)=>handleAnswerChange(item, changedValues)} current={current} pageSize={pageSize}/>
                            }
                        </List.Item>
                    }
                    case 2:{
                        return <List.Item
                            actions={!item.isEdit ? 
                                [
                                    hasEdit && <a onClick={()=>handleEdit(item, index)}><Space><EditOutlined /><span>Edit</span></Space></a>,
                                    <a onClick={()=>handleMore(item, index)}><Space><MoreOutlined /><span>More</span></Space></a>].filter(x=>x)
                                : 
                                [
                                    <a onClick={()=>handleConfirm(item, index)}><Space><EditOutlined /><span>Confirm</span></Space></a>,
                                    <a onClick={()=>handleCancel(item)}><Space><EditOutlined /><span>Cancel</span></Space></a>

                                ]
                            }
                        >
                            {!item.isEdit ? <MultipleChoiceItem item={item} index={index} current={current} pageSize={pageSize}/>
                            :
                            <EditMultipleChoiceItem  item={item} index={index} handleAnswerChange={(changedValues)=>handleAnswerChange(item, changedValues)} current={current} pageSize={pageSize}/>
                            }
                        </List.Item>
                    }
                    case 3:{
                        return <List.Item
                            actions={!item.isEdit ? 
                                [
                                    hasEdit && <a onClick={()=>handleEdit(item, index)}><Space><EditOutlined /><span>Edit</span></Space></a>,
                                    <a onClick={()=>handleMore(item, index)}><Space><MoreOutlined /><span>More</span></Space></a>].filter(x=>x)
                                : 
                                [
                                    <a onClick={()=>handleConfirm(item, index)}><Space><EditOutlined /><span>Confirm</span></Space></a>,
                                    <a onClick={()=>handleCancel(item)}><Space><EditOutlined /><span>Cancel</span></Space></a>

                                ]
                            }
                        >
                            {!item.isEdit ? <QuestionAndAnswerItem item={item} index={index} current={current} pageSize={pageSize}/>
                            :
                            <EditQuestionAndAnswerItem  item={item} index={index} handleAnswerChange={(changedValues)=>handleAnswerChange(item, changedValues)} current={current} pageSize={pageSize}/>
                            }
                        </List.Item>
                    }
                }
            }}
        />
    );
}


export default QuestionList;